import { TranslationKey } from "../i18n/translation-key"

export enum Month {
  JANUARY = 0,
  FEBRUARY = 1,
  MARCH = 2,
  APRIL = 3,
  MAY = 4,
  JUNE = 5,
  JULY = 6,
  AUGUST = 7,
  SEPTEMBER = 8,
  OCTOBER = 9,
  NOVEMBER = 10,
  DECEMBER = 11,
}

export interface MonthLabelKeys {
  nameKey: TranslationKey
  shortNameKey: TranslationKey
}

const MONTH_LABEL_KEYS: Record<Month, MonthLabelKeys> = {
  [Month.JANUARY]: {
    nameKey: "common.month.january.name",
    shortNameKey: "common.month.january.shortName",
  },
  [Month.FEBRUARY]: {
    nameKey: "common.month.february.name",
    shortNameKey: "common.month.february.shortName",
  },
  [Month.MARCH]: {
    nameKey: "common.month.march.name",
    shortNameKey: "common.month.march.shortName",
  },
  [Month.APRIL]: {
    nameKey: "common.month.april.name",
    shortNameKey: "common.month.april.shortName",
  },
  [Month.MAY]: {
    nameKey: "common.month.may.name",
    shortNameKey: "common.month.may.shortName",
  },
  [Month.JUNE]: {
    nameKey: "common.month.june.name",
    shortNameKey: "common.month.june.shortName",
  },
  [Month.JULY]: {
    nameKey: "common.month.july.name",
    shortNameKey: "common.month.july.shortName",
  },
  [Month.AUGUST]: {
    nameKey: "common.month.august.name",
    shortNameKey: "common.month.august.shortName",
  },
  [Month.SEPTEMBER]: {
    nameKey: "common.month.september.name",
    shortNameKey: "common.month.september.shortName",
  },
  [Month.OCTOBER]: {
    nameKey: "common.month.october.name",
    shortNameKey: "common.month.october.shortName",
  },
  [Month.NOVEMBER]: {
    nameKey: "common.month.november.name",
    shortNameKey: "common.month.november.shortName",
  },
  [Month.DECEMBER]: {
    nameKey: "common.month.december.name",
    shortNameKey: "common.month.december.shortName",
  },
}

export class MonthUtils {
  static getMonthLabelKeys(value: Month): MonthLabelKeys {
    return MONTH_LABEL_KEYS[value]
  }

  static monthFromDate(date: Date): Month {
    return date.getMonth() as Month
  }
}
